// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import moment from 'moment-timezone'
import './ChartSection.scss'
import { SecondaryButton } from 'ui_kit_qmd'
import classnames from 'classnames'
import { memo, useCallback } from 'react'
import chevronIcon from '../../../../images/common/ChevronUp.png'
import { EDIT_TEXT, LAST_UPDATED_TEXT, NEW_TEXT, SAVE_TEXT } from '../../../../utils/constants'
import plusIcon from '../../../../images/management/clinicMembers/plusIcon.png'
import { parseUserDateTime } from '../../../../utils/common'

const buttonContainerStyle = {
  width: 104,
  height: 40,
}

const newBtnContainerStyle = {
  justifyContent: 'center',
  maxHeight: 40,
  width: 88,
  marginRight: 24,
}

const editBtnContainerStyle = {
  justifyContent: 'center',
  maxHeight: 40,
  width: 'auto',
  marginRight: 24,
  padding: '0 9px',
}

const newBtnImageStyle = {
  height: 16.5,
  width: 16.5,
  marginRight: 5,
}

const classNames = {
  expandedHeader: 'chart-section-header--expanded',
}

export const ChartSection = memo(
  ({
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    id,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    title,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    lastUpdated,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    icon,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    iconAltText,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    emptyText,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setIsCollapsed,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    clickButtonAction,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isCollapsed,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isWithoutLastUpdated,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isWithoutSeparateLine,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isWithNewIndicator,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isNewButton,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isShowButton,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isShowEmptyContent,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isShouldScrollUpContent,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isEditMode,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    children,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    customButton,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    className = '',
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    userTimeZone,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    forceEmpty,
  }) => {
    const toggleIsCollapsedState = useCallback(() => {
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      setIsCollapsed((prev) => !prev)
    }, [setIsCollapsed])

    const onClickNewButton = useCallback(() => {
      if (isShouldScrollUpContent && !isCollapsed) {
        const contentContainer = document.getElementById(`${title}-chart-section`)
        // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
        contentContainer.scrollTo(0, 0)
      }
      clickButtonAction()
    }, [clickButtonAction, isCollapsed, isShouldScrollUpContent, title])

    const onClickEditSaveButton = useCallback(() => {
      if (!isEditMode && isCollapsed) {
        setIsCollapsed(false)
      }
      clickButtonAction()
    }, [clickButtonAction, isCollapsed, isEditMode, setIsCollapsed])

    return (
      <div id={id} className={classnames('chart-section-main-wrapper', { [className]: className })}>
        <div className={classnames('chart-section-header', { [classNames.expandedHeader]: !isCollapsed })}>
          <div className='chart-section-header-left-side'>
            <img className='chart-section-header-icon' src={icon} alt={iconAltText} />
            <div className='chart-section-header-left-side-text-wrapper'>
              <div className='chart-section-text chart-section-title'>{title}</div>
              <div className={`chart-section-text${isWithoutLastUpdated ? 'chart-section-last-updated-hidden' : ''}`}>
                {LAST_UPDATED_TEXT}: {lastUpdated ? parseUserDateTime(lastUpdated, userTimeZone, false) : '--'}
              </div>
            </div>
          </div>
          <div className='chart-section-header-right-side'>
            {isWithNewIndicator ?
              <div className='chart-section-text chart-section-new-indicator'>{NEW_TEXT}!</div>
            : null}
            {isShowButton ?
              <div>
                {isNewButton ?
                  <SecondaryButton
                    id='chart-section-new-button'
                    image={plusIcon}
                    imageStyle={newBtnImageStyle}
                    btnText={NEW_TEXT}
                    onPress={onClickNewButton}
                    containerStyle={{
                      ...buttonContainerStyle,
                      ...newBtnContainerStyle,
                    }}
                  />
                : customButton || (
                    <SecondaryButton
                      id='chart-section-edit-button'
                      btnText={isEditMode ? SAVE_TEXT : EDIT_TEXT}
                      onPress={onClickEditSaveButton}
                      containerStyle={{
                        ...buttonContainerStyle,
                        ...newBtnContainerStyle,
                        ...editBtnContainerStyle,
                      }}
                    />
                  )
                }
              </div>
            : null}
            <img
              role='presentation'
              className={`chart-section-header-chevron ${
                isCollapsed ? 'chart-section-header-chevron--down' : 'chart-section-header-chevron--up'
              }`}
              onClick={toggleIsCollapsedState}
              src={chevronIcon}
              alt='chevron'
            />
          </div>
        </div>
        {!isCollapsed &&
          (children && !forceEmpty ?
            <div id={`${title}-chart-section`} className='chart-section-content-wrapper'>
              {children}
              {isShowEmptyContent ?
                <div className='chart-section-text chart-section-empty'>{emptyText}</div>
              : null}
            </div>
          : <div className={classnames('chart-section-empty-container', { 'force-empty': forceEmpty })}>
              {children}
              <div className='chart-section-text chart-section-empty'>{emptyText}</div>
            </div>)}
        {!isWithoutSeparateLine && <div className='chart-section-separate-line' />}
      </div>
    )
  },
)
